// @mui
import { withStyles } from '@mui/styles';

export const style = (theme) => ({
  autocomplete: {
    '& .MuiInput-root .MuiInput-input': {
      paddingTop: '0 !important',
      paddingBottom: '5px',
      paddingLeft: '0',
      paddingRight: '4px',
    },
  },
});

export const withLocalityStyles = withStyles(style);

